/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1DocumentCourseEnrollmentDocumentDropdown200,
  GetApiV1DocumentCourseEnrollmentDocumentDropdown401,
  GetApiV1DocumentCourseEnrollmentDocumentDropdown500,
  GetApiV1DocumentCourseEnrollmentDocumentDropdownQueryParams,
  GetApiV1DocumentCourseEnrollmentDocumentDropdownQueryResponse,
} from "../../types/documentCourseController/GetApiV1DocumentCourseEnrollmentDocumentDropdown.ts";
import { dropDownRepositoryResponseSchema } from "../dropDownRepositoryResponseSchema.ts";

export const getApiV1DocumentCourseEnrollmentDocumentDropdownQueryParamsSchema =
  z
    .object({
      filter: z.optional(z.string()),
    })
    .optional() as unknown as ToZod<GetApiV1DocumentCourseEnrollmentDocumentDropdownQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1DocumentCourseEnrollmentDocumentDropdown200Schema =
  z.array(
    z.lazy(() => dropDownRepositoryResponseSchema),
  ) as unknown as ToZod<GetApiV1DocumentCourseEnrollmentDocumentDropdown200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1DocumentCourseEnrollmentDocumentDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseEnrollmentDocumentDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1DocumentCourseEnrollmentDocumentDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseEnrollmentDocumentDropdown500>;

export const getApiV1DocumentCourseEnrollmentDocumentDropdownQueryResponseSchema =
  z.lazy(
    () => getApiV1DocumentCourseEnrollmentDocumentDropdown200Schema,
  ) as unknown as ToZod<GetApiV1DocumentCourseEnrollmentDocumentDropdownQueryResponse>;
